import React, { FC, useEffect, useRef, useState } from 'react'
import classes from './styles.module.scss'
import { useTranslation } from 'react-i18next';
import { useKato } from '../../../contexts/kato.context';
import { GeneralInfoStatus, KatoType } from '../../../types/kato.types';
import { useNavigate, useParams } from 'react-router-dom';
import { changeStatus, deleteAll, deleteInfrastructureProject } from '../../../requests/supervisor.request';
import { ToastContainer } from 'react-toastify';
import Modal from '../../../components/modal/modal.component';
import { useShared } from '../../../contexts/shared.context';
import { InfrastructureProjectType } from '../../../types/project.types';
import { isInfrastructureProjectType } from '../../../helpers/utils';

const baseClass = 'footer-component';

interface IProps {
  onSave: () => void;
  status?: GeneralInfoStatus;
  validateFields: () => boolean;
}
const FooterComponent: FC<IProps> = ({
  onSave,
  status,
  validateFields
}) => {
  const { t } = useTranslation();
  const { currentLevel, updatedGeneralInfo } = useKato()
  const { selectedInfoYear } = useShared()
  const { kato, link, tab, id } = useParams<{ kato: string, link: string, tab: string, id: string }>();
  const [isCompleted, setIsCompleted] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const footerRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!kato) return;
    if (e.target.checked) {
      if (validateFields()) {
        setIsCompleted(true);
        changeStatus(+kato, GeneralInfoStatus.COMPLETED).then(() => {
          updatedGeneralInfo();
        });
      } else {
        setIsCompleted(false);
        changeStatus(+kato, GeneralInfoStatus.IN_PROCESS).then(() => {
          updatedGeneralInfo();
        });
      }
    }
  };

  const handleSave = () => {
    if (isSaving) return;

    setIsSaving(true);
    onSave();
    setTimeout(() => {
      setIsSaving(false);
    }, 1000);
  };

  const handleDelete = () => {
    if (!kato) return;
    setIsOpen(true);
  }

  const confirmDelete = () => {
    if (!kato) return;
    if (isInfrastructureProjectType(link as string) || isInfrastructureProjectType(tab as string)) {
      const type = isInfrastructureProjectType(link as string) ? link : tab;
      const objectId = isInfrastructureProjectType(link as string) ? tab : id;
      const returnUrl = isInfrastructureProjectType(link as string) ? `/admin/${kato}/${link}` : `/admin/${kato}/${link}/${tab}`;
      if (!type || !objectId) return;
      deleteInfrastructureProject(type as InfrastructureProjectType, +objectId)
        .then(() => {
          navigate(returnUrl);
        });
    } else {
      deleteAll(+kato, selectedInfoYear).then(() => {
        navigate('/admin')
      });
    }

  }

  const handleGoUp = () => {
    const element = document.querySelector('[class*="edit-item-page__content"]');

    if (element) {
      element.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const showDelete = link === 'general-info' || isInfrastructureProjectType(link as string) || isInfrastructureProjectType(tab as string);

  useEffect(() => {
    setIsCompleted(status === GeneralInfoStatus.COMPLETED);
  }, [status]);

  return (
    <>
      <div className={classes[baseClass]} ref={footerRef}>
        <div className={classes[`${baseClass}__left`]}>
          <div className={`${classes[`${baseClass}__btn`]} ${classes[`${baseClass}__btn--green`]}`} onClick={handleSave}>
            {t('actions.save')}
          </div>
          {link === 'general-info' && <div className='checkbox'>
            <input type="checkbox" name="is-finished" id="is-finished" checked={isCompleted} onChange={handleCheckboxChange} />
            {currentLevel !== KatoType.OBLAST ? <label htmlFor="is-finished">{t(`${kato && currentLevel === KatoType.REGION ? 'region' : 'so'}-is-finished`)}</label>
              : <label htmlFor="is-finished">Область заполнена полностью</label>}
          </div>}
        </div>
        <div className={classes[`${baseClass}__right`]}>
          {showDelete && <div className={`${classes[`${baseClass}__btn`]} ${classes[`${baseClass}__btn--red`]}`} onClick={handleDelete}>
            {t('actions.delete')}
          </div>}
          <div className={`${classes[`${baseClass}__btn`]}`} onClick={handleGoUp}>
            {t('actions.go-up')}
          </div>
        </div>
      </div>
      <ToastContainer autoClose={2000} />

      <Modal
        show={isOpen}
        handleClose={() => setIsOpen(false)}
      >
        <div className={classes[`${baseClass}__modal-content`]}>
          <span>Вы действительно хотите удалить все данные?</span>
          <div className={classes[`${baseClass}__modal-actions`]}>
            <button className={`${classes[`${baseClass}__btn`]} ${classes[`${baseClass}__btn--red`]}`} onClick={confirmDelete}>{t('actions.confirm')}</button>
            <button className={`${classes[`${baseClass}__btn`]} ${classes[`${baseClass}__btn--clear`]}`} onClick={() => setIsOpen(false)}>{t('actions.cancel')}</button>
          </div>
        </div>
      </Modal>
    </>

  )
}

export default FooterComponent